<div class="row influencer-preview-container" [ngClass]="{'odd': !evenRow, 'even': evenRow, 'post-review': displayInfo === 'posts'}" *ngIf="hasInfluencerData()">
  <div class="col-md-12">
    <div>
      <div class="row">
        <div class="col-xl-7 col-lg-6 col-md-12 no-padding">
          <div class="d-flex flex-row">
            <div class="select-influencer" (click)="onSelectedInfluencer(influencer, $event)">
              <achoo-checkbox name="preview_influencer_{{influencer.influencer_id}}" *ngIf="previewedMode"
                              [(model)]="influencer.previewed">
              </achoo-checkbox>
              <achoo-checkbox name="select_influencer_{{influencer.influencer_id}}" *ngIf="!previewedMode"
                              [(model)]="influencer.selected" >
              </achoo-checkbox>
            </div>
            <a [routerLink]="entryLink"
               [queryParams]="linkParams"
               queryParamsHandling="merge"
               target="_blank" class="d-flex flex-row influencer-data-container" style="display: block">
              <div *ngIf="displayInfo !== 'posts'" class="influencer-avatar d-flex align-items-center">
                <achoo-user-avatar [avatarHeight]="7.25"
                                   [avatarWidth]="7.25"
                                   [countryHeight]="2.5"
                                   [countryWidth]="2.5"
                                   [showCountryFlagIcon]="true"
                                   [userAvatarPicture]="influencer.influencer_image"
                                   [userCountryCode]="getCountryCode(influencer)"
                                   [isTopCountryFlag]="true">
                </achoo-user-avatar>
              </div>
              <div *ngIf="displayInfo === 'posts'" class="post-image-container">
                <blurry-backdrop-image [image]="influencer.imageUrl" [height]="115"></blurry-backdrop-image>
              </div>
              <div class="user-summarize d-flex flex-column">
                <span class="preview-influencer-name">{{getPreviewedItemTitle(influencer)}}</span>
                <div class="d-flex flex-row preview-influencer-subtitle subtitle-margin">
                  <span>{{getInfluencerHandle(influencer)}}</span>
                </div>
                <div class="preview-influencer-seperator"></div>
                <div class="d-flex flex-column">
                  <div class="d-flex flex-row">
                    <span *ngIf="displayInfo !== 'posts'" class="preview-influencer-introduce-title ellipsis">{{'group_details.preview_influencer.top_mentions' | translate}}</span>
                    <span *ngIf="displayInfo === 'posts'" class="preview-influencer-introduce-title ellipsis">{{'discover.preview_influencer.mentions' | translate}}:</span>
                    <span class="preview-influencer-title ellipsis">{{influencer.topMention}}</span>
                  </div>
                  <div class="d-flex flex-row" *ngIf="displayInfo !== 'posts'">
                    <span class="preview-influencer-introduce-title subtitle-margin ellipsis">{{'group_details.preview_influencer.favorite_topic' | translate}}</span>
                    <span class="preview-influencer-title subtitle-margin ellipsis">{{influencer.favoriteTopics}}</span>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
        <a [routerLink]="['/influencer/' + influencer.influencer_id +'/overview']"
           [queryParams]="{group_id: influencerGroupId, activeAccount: activeAccount, target: 'discover'}"
           queryParamsHandling="merge"
           target="_blank" style="display: block" class="col-xl-5 col-lg-6 col-md-12">
          <div class="row">
            <div class="col-lg-8 col-md-7 col-sm-12">
              <div class="list-platform d-flex flex-row justify-content-end align-items-center full-height" [ngClass]="{'preview-post-platforms': displayInfo === 'posts'}">
                <div class="d-flex flex-row justify-content-end" *ngIf="displayInfo !== 'posts'">
                  <div *ngFor="let platform of platformList" class="icon-display">
                    <div class="{{platform.name.toLowerCase() + '-icon'}}" [ngClass]="{'lg-icon preview-post-icon': displayInfo === 'posts', 'hidden-icon': !hasPlatform(platform.id, influencer)}"></div>
                  </div>
                </div>
                <div class="d-flex flex-row justify-content-end" *ngIf="displayInfo === 'posts'">
                  <div class="icon-display">
                    <div class="{{influencer.platform.toLowerCase() + '-icon lg-icon preview-post-icon'}}"></div>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-lg-4 col-md-5 col-sm-12">
              <div class="d-flex justify-content-end mr-2">
                <div class="influencer-number-wrapper justify-content-center d-flex flex-column" *ngIf="displayInfo !== 'posts'">
                  <div class="d-flex flex-row">
                    <div class="influencer-info-wrapper top left influencer-number-info d-flex flex-column">
                      <div class="number-title d-flex justify-content-end"
                           placement="bottom"
                           ngbTooltip="{{'info_box.discover.follower' | translate}}">
                        {{'group_details.preview_influencer.followers' | translate}}
                      </div>
                      <div class="number-data d-flex justify-content-end">{{influencer.numberOfFollowers | thousandNumberSuffix}}</div>
                    </div>
                    <div class="influencer-info-wrapper top right d-flex flex-column">
                      <div class="number-title d-flex justify-content-start"
                           placement="bottom-right"
                           ngbTooltip="{{'info_box.discover.post_count' | translate}}">
                        {{'group_details.preview_influencer.post' | translate}}
                      </div>
                      <div class="number-data d-flex justify-content-start">{{influencer.numberOfPosts | thousandNumberSuffix}}</div>
                    </div>
                  </div>
                  <div class="seperate-influencer-line"></div>
                  <div class="d-flex flex-row">
                    <div class="influencer-info-wrapper bottom left influencer-number-info d-flex flex-column justify-content-end">
                      <div class="number-title avg-reach d-flex justify-content-end"
                           placement="bottom"
                           ngbTooltip="{{'info_box.discover.reach' | translate}}">
                        {{'group_details.preview_influencer.reach' | translate}}
                      </div>
                      <div class="number-data d-flex justify-content-end">{{influencer.reach | thousandNumberSuffix}}</div>
                    </div>
                    <div class="influencer-info-wrapper bottom right d-flex flex-column">
                      <div class="number-title d-flex justify-content-start"
                           placement="bottom-right"
                           ngbTooltip="{{'info_box.discover.impact' | translate}}">
                        {{'group_details.preview_influencer.impact' | translate}}
                      </div>
                      <div class="number-data d-flex justify-content-start">{{influencer.impact | percentNumberSuffix}}</div>
                    </div>
                  </div>
                </div>
                <div class="influencer-number-wrapper justify-content-center d-flex flex-column" *ngIf="displayInfo === 'posts'">
                  <div class="d-flex flex-row">
                    <div class="influencer-info-wrapper top left influencer-number-info d-flex flex-column">
                      <div class="number-title d-flex justify-content-end"
                           placement="bottom"
                           ngbTooltip="{{'info_box.discover.impression' | translate}}">
                        {{'group_details.preview_influencer.impressions' | translate}}
                      </div>
                      <div class="number-data d-flex justify-content-end">{{influencer.impressions | thousandNumberSuffix}}</div>
                    </div>
                    <div class="influencer-info-wrapper top right d-flex flex-column">
                      <div class="number-title d-flex justify-content-start"
                           placement="bottom-right"
                           ngbTooltip="{{'info_box.discover.reach' | translate}}">
                        {{'group_details.preview_influencer.reach' | translate}}
                      </div>
                      <div class="number-data d-flex justify-content-start">{{influencer.reach | thousandNumberSuffix}}</div>
                    </div>
                  </div>
                  <div class="seperate-influencer-line"></div>
                  <div class="d-flex flex-row">
                    <div class="influencer-info-wrapper bottom left influencer-number-info d-flex flex-column justify-content-end">
                      <div class="number-title d-flex justify-content-end"
                           placement="bottom"
                           ngbTooltip="{{'info_box.discover.engagement' | translate}}">
                        {{'group_details.preview_influencer.engagement' | translate}}
                      </div>
                      <div class="number-data d-flex justify-content-end">{{influencer.engagement | thousandNumberSuffix}}</div>
                    </div>
                    <div class="influencer-info-wrapper bottom right d-flex flex-column">
                      <div class="number-title d-flex justify-content-start"
                           placement="bottom-right"
                           ngbTooltip="{{'info_box.discover.impact' | translate}}">
                        {{'group_details.preview_influencer.impact' | translate}}
                      </div>
                      <div class="number-data d-flex justify-content-start">{{influencer.impact | percentNumberSuffix}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/main/group-details/preview-selected-influencers/preview-influencer-item/preview-influencer-item.component.html